import { Injectable } from "@nestjs/common";
import { DataSource, Repository } from "typeorm";
import { CollegeCodesAndSymobols } from "../entities/college-codes-symbols.entity";

@Injectable()
export class CollegeCodesAndSymbolsRepo extends Repository<CollegeCodesAndSymobols>{
    constructor(private dataSource: DataSource) {
        super(CollegeCodesAndSymobols, dataSource.createEntityManager());
    }
}